/* eslint-disable class-methods-use-this */
import EventClass from "common/utils/ui/event-class";

class MagnifierMouseMoveHandler extends EventClass {
  #$imageBox = undefined;

  get #$original() {
    return this.#$imageBox.querySelector(".js-magnify-image");
  }

  get #$magnified() {
    return this.#$imageBox.querySelector(".js-magnify-preview");
  }

  get #$lens() {
    return this.#$imageBox.querySelector(".js-magnify-lens");
  }

  get #$panel() {
    return document.querySelector(".js-info-right");
  }

  constructor(props) {
    super(props);
    this.#$imageBox = document.querySelector(props.eventSelector);
  }

  #getDimensions($element) {
    return {
      width: $element.offsetWidth,
      height: $element.offsetHeight,
      actualWidth: $element.naturalWidth,
      actualHeight: $element.naturalHeight
    };
  }

  #getMouseCoordinates(e) {
    const imageBoxRect = this.#$original.getBoundingClientRect();
    // Use clientX/clientY for viewport-relative coordinates
    const x = e.clientX - imageBoxRect.left;
    const y = e.clientY - imageBoxRect.top;

    let xPerc = (x / imageBoxRect.width) * 100;
    let yPerc = (y / imageBoxRect.height) * 100;

    // Lets user scroll past horizontal edge of image
    if (x >= 0.01 * imageBoxRect.width) {
      xPerc *= 1.15;
    }

    // Lets user scroll past vertical edge of image
    if (y >= 0.01 * imageBoxRect.height) {
      yPerc *= 1.15;
    }

    return { x, y, xPerc, yPerc };
  }

  #constrain(num, min, max) {
    const MIN = min ?? Number.MIN_VALUE;
    const MAX = max ?? Number.MAX_VALUE;
    const parsed = Math.round(parseFloat(num));
    return Math.min(Math.max(parsed, MIN), MAX);
  }

  /**
   * @returns void
   * @override EventClass.event
   * @description This method is called when the mouse is moved over the image.
   */
  event(e) {
    if (!this.#$original) return;

    const { x, y, xPerc, yPerc } = this.#getMouseCoordinates(e);

    const { width, height } = this.#getDimensions(this.#$original);

    // Set lens to be 1/9 of the image (1/3 width × 1/3 height)
    const lensWidth = width / 3;
    const lensHeight = height / 3;

    const lensHorizontal = this.#constrain(x, lensWidth / 2, width - lensWidth / 2);
    const lensVertical = this.#constrain(y, lensHeight / 2, height - lensHeight / 2);

    requestAnimationFrame(() => {
      this.#$lens.style.left = `${lensHorizontal}px`;
      this.#$lens.style.top = `${lensVertical}px`;
      this.#$lens.style.width = `${lensWidth}px`;
      this.#$lens.style.height = `${lensHeight}px`;
      // Calculate zoom factor based on lens being 1/3 of image dimensions
      const zoomFactor = 3; // Since lens is 1/3, we need 3x zoom
      const backgroundSizePercent = zoomFactor * 100;
      this.#$magnified.style.backgroundSize = `${backgroundSizePercent}%, 20%`;
      this.#$magnified.style.backgroundPosition = `${xPerc - 10}% ${yPerc - 10}%, center`;
    });
  }
}

export default props => new MagnifierMouseMoveHandler({ event: "mousemove", ...props });
